// extracted by mini-css-extract-plugin
export default {"tableFooter":"table-footer_tableFooter__n2J8K","pageRange":"table-footer_pageRange__t7uhQ","footerButtonGroup":"table-footer_footerButtonGroup__Cy-Wk"};